import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Modal, Switch, Stack, SimpleGrid, TextInput, Textarea, PasswordInput, Center, Box, Progress, Badge, NumberInput, PinInput, Checkbox } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin,
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { Admin_Bank_Add, Admin_Bank_Delete, Admin_Banks_get, Get_All_Users, Get_Individual_user_wallet_details, Get_LoginLogs, Master_Dist_Signup, Update_Master_dist_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";
import { IconCheck, IconX } from "@tabler/icons-react";
const { Search } = Input;










const Loginlogs = ({ Headername }) => {
    const columns = [
        {
            title: "S.No.",
            width: 60,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "User",
            width: 220,
            render: (_, record) => (
                <>
                    <Text fw={600}>{record.userName}</Text>
                    <Text size="xs" c="dimmed">
                        {record.userCode}
                    </Text>
                </>
            ),
        },
        {
            title: "Type",
            dataIndex: "userType",
            width: 130,
            render: (type) => (
                <Tag
                    color={
                        type === "Admin"
                            ? "red"
                            : type === "Master Distributor"
                                ? "purple"
                                : type === "Distributor"
                                    ? "blue"
                                    : "green"
                    }
                >
                    {type}
                </Tag>
            ),
        },
        {
            title: "Status",
            dataIndex: "loginStatus",
            width: 100,
            align: "center",
            render: (status) => (
                <Tag color={status === "SUCCESS" ? "green" : "red"}>
                    {status}
                </Tag>
            ),
        },
        {
            title: "Location",
            width: 180,
            render: (_, record) => (
                <>
                    <Text>{record.location?.city}</Text>
                    <Text size="xs" c="dimmed">
                        {record.location?.state}
                    </Text>
                </>
            ),
        },
        {
            title: "Device",
            width: 160,
            render: (_, record) => (
                <>
                    <Text>{record.browser}</Text>
                    <Text size="xs" c="dimmed">
                        {record.os}
                    </Text>
                </>
            ),
        },
        {
            title: "Login Time",
            dataIndex: "loginTime",
            width: 180,
            render: (date) =>
                dayjs(date).format("DD MMM YYYY hh:mm A"),
        },
        {
            title: "Action",
            width: 90,
            fixed: "right",
            render: (_, record) => (
                <Button
                    variant="outline"
                    size="xs"
                    onClick={() => {
                        setsetSelectedLog(record);
                        setLoginLogDrawer(true);
                    }}
                >
                    View
                </Button>
            ),
        },
    ];
    const { user } = Userauthcontexthooks();
    const [fetchlogsLoading, setFetchlogsLoading] = useState(true);
    const [Loginlogs, setloginlogs] = useState([]);
    const [FilteredLoginlogs, setFilteredLoginlogs] = useState([]);
    const [searchlogs, setsearchlogs] = useState('');
    const [selectedLog, setsetSelectedLog] = useState(null);
    const [LoginLogDrawer, setLoginLogDrawer] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });


    const handleSearch = () => {
        let filtered = [...Loginlogs];

        // Search Filter
        if (searchlogs.trim()) {
            const keyword = searchlogs.toLowerCase().trim();

            filtered = filtered.filter((item) =>
                item.userName?.toLowerCase().includes(keyword) ||
                item.userCode?.toLowerCase().includes(keyword)
            );
        }

        setFilteredLoginlogs(filtered);
    };

    const handleReset = () => {
        setsearchlogs("");
        setFilteredLoginlogs(Loginlogs);
    };

    const fetchLogs = async (page = 1, pageSize = 10) => {
        try {
            const data = await Get_LoginLogs(page, pageSize);
            if (data.success) {
                //console.log(data);
                setloginlogs(data?.Loginlogs);
                setFilteredLoginlogs(data?.Loginlogs);

                setPagination({
                    current: data.pagination.current,
                    pageSize: data.pagination.pageSize,
                    total: data.pagination.total,
                });
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setFetchlogsLoading(false);
        }
    }

    useEffect(() => {
        const fetchLogs = async (page = 1, pageSize = 10) => {
            try {
                const data = await Get_LoginLogs(page, pageSize);
                if (data.success) {
                    //console.log(data);
                    setloginlogs(data?.Loginlogs);
                    setFilteredLoginlogs(data?.Loginlogs);

                    setPagination({
                        current: data.pagination.current,
                        pageSize: data.pagination.pageSize,
                        total: data.pagination.total,
                    });
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setFetchlogsLoading(false);
            }
        }

        if (user) {
            fetchLogs();
        }

    }, [user])

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Login Logs</Title>
                <Text size="xs">You can view where have to use id's</Text>
            </Container>
            <Container size={'lg'} mt={'lg'}>
                <Card title="Logs" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search by Name/ Code"
                                allowClear
                                value={searchlogs}
                                onChange={(e) => setsearchlogs(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={FilteredLoginlogs}
                            loading={fetchlogsLoading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={pagination}
                            onChange={(page) => {
                                fetchLogs(page.current, page.pageSize);
                                setFetchlogsLoading(true)
                            }}
                        />
                    </div>

                </Card>
            </Container>

            <Drawer
                title="Login Log Details"
                width={700}
                opened={LoginLogDrawer}
                onClose={() => {
                    setLoginLogDrawer(false);
                    setsetSelectedLog(null);
                }}
            >
                {selectedLog && (
                    <>

                        {/* Basic Information */}

                        <Descriptions
                            title="Basic Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="User Name">
                                {selectedLog.userName}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Code">
                                <Text copyable>
                                    {selectedLog.userCode}
                                </Text>
                            </Descriptions.Item>

                            <Descriptions.Item label="User Type">
                                <Tag
                                    color={
                                        selectedLog.userType === "Admin"
                                            ? "red"
                                            : selectedLog.userType === "Master Distributor"
                                                ? "purple"
                                                : selectedLog.userType === "Distributor"
                                                    ? "blue"
                                                    : "green"
                                    }
                                >
                                    {selectedLog.userType}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Login Status">
                                <Tag color={selectedLog.loginStatus === "SUCCESS" ? "green" : "red"}>
                                    {selectedLog.loginStatus}
                                </Tag>
                            </Descriptions.Item>

                            <Descriptions.Item label="Login Method">
                                {selectedLog.loginMethod}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        {/* Device */}

                        <Descriptions
                            title="Device Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Browser">
                                {selectedLog.browser}
                            </Descriptions.Item>

                            <Descriptions.Item label="Operating System">
                                {selectedLog.os}
                            </Descriptions.Item>

                            <Descriptions.Item label="Device Type">
                                {selectedLog.deviceType || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Device Name">
                                {selectedLog.deviceName || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="User Agent">
                                <Text copyable>
                                    {selectedLog.userAgent}
                                </Text>
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        {/* Location */}

                        <Descriptions
                            title="Location Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Country">
                                {selectedLog.location?.country}
                            </Descriptions.Item>

                            <Descriptions.Item label="State">
                                {selectedLog.location?.state}
                            </Descriptions.Item>

                            <Descriptions.Item label="City">
                                {selectedLog.location?.city}
                            </Descriptions.Item>

                            <Descriptions.Item label="Pincode">
                                {selectedLog.location?.pincode}
                            </Descriptions.Item>

                            <Descriptions.Item label="Latitude">
                                {selectedLog.location?.latitude}
                            </Descriptions.Item>

                            <Descriptions.Item label="Longitude">
                                {selectedLog.location?.longitude}
                            </Descriptions.Item>

                            <Descriptions.Item label="Full Address">
                                {selectedLog.location?.address}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        {/* Session */}

                        <Descriptions
                            title="Session Information"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="IP Address">
                                <Text copyable>
                                    {selectedLog.ipAddress}
                                </Text>
                            </Descriptions.Item>

                            <Descriptions.Item label="Login Time">
                                {dayjs(selectedLog.loginTime).format(
                                    "DD MMM YYYY hh:mm:ss A"
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="Logout Time">
                                {selectedLog.logoutTime
                                    ? dayjs(selectedLog.logoutTime).format(
                                        "DD MMM YYYY hh:mm:ss A"
                                    )
                                    : "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Session Duration">
                                {selectedLog.sessionDuration || "-"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Logout By">
                                {selectedLog.logoutBy || "-"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        {/* Remarks */}

                        <Descriptions
                            title="Remarks"
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="Remarks">
                                {selectedLog.remarks}
                            </Descriptions.Item>
                        </Descriptions>

                    </>
                )}
            </Drawer>
        </>
    )
}

export default Loginlogs;